import React from 'react'
import { Box, InputAdornment, OutlinedInput } from '@mui/material'
import { SearchIcon } from 'Sui_Icons'


export const SearchBox = () => {
    return (
        <Box sx={{ flexBasis: '30%' }}>
            <OutlinedInput
                sx={{ borderRadius: 1, fontSize: '14px', my: 0, p: 0 }}
                placeholder='جستجو'
                fullWidth
                startAdornment={<InputAdornment position="start" >
                    <SearchIcon sx={{ cursor: 'pointer' }} />
                </InputAdornment>}
            />
        </Box>
    )
}
